import { render, staticRenderFns } from "./WildcardPresenterComponent.vue?vue&type=template&id=3f0550d3&scoped=true&"
import script from "./WildcardPresenterComponent.vue?vue&type=script&lang=js&"
export * from "./WildcardPresenterComponent.vue?vue&type=script&lang=js&"
import style0 from "./WildcardPresenterComponent.vue?vue&type=style&index=0&id=3f0550d3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0550d3",
  null
  
)

export default component.exports